import {Link} from "react-router-dom";
import notFoundLogo from "../assets/NotFoundLogo.png"
import React ,{useEffect} from "react";

const NotFound404 = (props)=>{
      useEffect(() => {
        props.showLoading()
        setTimeout(()=>{
            props.completeLoading()
        },100)
      }, [])
      
        
        document.title = props.title
    return (
      <>
      <div className={`${props.theme==="dark"?"text-light":""}`} style={{minHeight:"90vh", overflowY: "hidden"}}>
        <div className="d-flex justify-content-center mt-4"><img src={notFoundLogo}  style={{width: "250px"}} alt="404NotFound" /></div>
        <div className="container">
        <h1 className='pt-4 pb-3 text-center'>404 Page Not Found</h1>
        <p className={`text-center mb-4 fs-5 text-${props.theme==="dark"?"secondary":"muted"}`}>We are sorry, but the page you are looking for does not exist.</p>
        <div className="d-flex justify-content-center"><Link className='btn btn-outline-warning fs-5' to='/'>Return to HomePage</Link></div>
        </div>
        </div>
      </>  
    )
}

export default NotFound404